module.exports = __webpack_public_path__ + "media/images/proof_links/colored/stumbleupon-754f477fd7df6cff5127f42c6d17a7b9.svg";